module.exports = __webpack_public_path__ + "media/images/alambique-desktop-xl-3d880660bdc554f26be399ca50489e24.jpg";